<template>
    <div class=" col-12 pt-4">
        <div class="row text-md-left mt-3 pb-3 justify-content-center">
            <svg-icon class="mr-3 question-mark-icon"  name="question-mark" width="64" height="auto"></svg-icon>
            <div>
                <h2>Need support or advice? </h2>
                <h2>Get in touch <a class="text-dark underline" id="contact" v-bind:href="this.support" target="__blank">send an enquiry</a> </h2>
            </div>
        </div>
     </div>
</template>
<script>

const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {
    data() {
        return {
            support: whitelabel.support,
        }
    },
}
</script>
<style>
.white{
    color: white
}
.white-line{
    border: 1px solid white
}
.address-margin{
    margin-left: 0px
}
</style>
